// Module
var code = "<div class=\"iframe-container\"> <iframe ng-if=\"url\" ng-src=\"{{ url + '&skipPreloading=1' }}\" scrolling=\"auto\"></iframe> </div> <add-item class=\"fab-bottom-right fab-bottom-up\" sale=\"sale\"></add-item> ";
// Exports
module.exports = code;